<template>
  <div>
    <div class="opo02">
      <span class="opo03" @click="back()">刀具柜列表 ></span>
      <span class="opo04"> 广告页</span>
    </div>
    <div class="ggs01">
      <div class="ggs02">
        <div class="ggs03">
          <div class="ggs05">
            <p class="ggs04"><span class="ggs06">*</span>广告页</p>
            <div class="ggs07">
              <div class="ggs08">
                <div class="ggs09">选择上传的图片</div>
              </div>
              <p class="ggs10">格式：JPG、PNG、JPEG</p>
              <Upload
                class="upd01"
                :on-success="succGz"
                :multiple="false"
                type="drag"
                action="/load/gyy/api/uploadfile">
                <div>
                  <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                  <p>点击或者拖拽以上传图片</p>
                </div>
              </Upload>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ggs11">
      <div class="ggs12">
        <div class="ggs13" v-for="(item,index) in imageUrl" :key="'img'+index">
          <img :src="item.url" @mouseout="toYc(item)" @mouseover="toXs(item)" class="ggs14" alt="">
          <div class="ggs15" v-show="item.is_check" @mouseout="toYc(item)" @mouseover="toXs(item)" @click="toDel(item)">
            <img src="@/assets/images/del.png" class="ggs16" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  var me;
  var user;
  import httpUser from "@/api/user";
  import util from '@/util/util';
  export default {
    name: "djggg",
    data(){
      return{
        imageUrl:[],//编辑存有缩略图
        sbid:'',
        data:[],
      }
    },
    created() {
      me = this;
      user = JSON.parse(sessionStorage.getItem('user'));
    },
    mounted() {
      me.sbid = me.$route.query.id;
      let data = {
        deviceid:me.sbid,
      }
      httpUser.adlist(data).then(res => {
        console.log(res);
        // me.data = res.data.datalist;
        res.data.datalist.forEach(function (item,index) {
          let data = {
            id:item.id,
            url:item.url,
            is_check:false,
          }
          me.imageUrl.push(data);
        })
      })
    },
    methods:{
      toDel(item){//删除图片
        // console.log(item);return false;
        me.$Loading.start();
        let data = {
          id:item.id,
          deviceid:me.sbid
        }
        httpUser.delad(data).then(res => {
          switch (res.code) {
            case "0000":
              let data = {
                deviceid:me.sbid,
              }
              me.imageUrl = [];
              httpUser.adlist(data).then(res => {
                console.log(res);
                // me.data = res.data.datalist;
                res.data.datalist.forEach(function (item,index) {
                  let data = {
                    id:item.id,
                    url:item.url,
                    is_check:false,
                  }
                  me.imageUrl.push(data);
                })
                me.$Loading.finish();
                me.$message.success('已删除');
              })
              break;
            case "1111":
              me.$Loading.error();
              me.$message.error('请稍后再试');
              break;
          }
        })
      },
      succGz(e){//文件上传成功后的钩子
        me.$Loading.start();
        let data1 = {
          url:e.data,
          deviceid:me.sbid,
        }
        httpUser.addorupdatecupad(data1).then(res => {
          let data = {
            deviceid:me.sbid,
          }
          me.imageUrl = [];
          httpUser.adlist(data).then(res => {
            console.log(res);
            // me.data = res.data.datalist;
            res.data.datalist.forEach(function (item,index) {
              let data = {
                id:item.id,
                url:item.url,
                is_check:false,
              }
              me.imageUrl.push(data);
            })
            me.$Loading.finish();
            me.$message.success('添加成功');
          })
        })
      },
      toXs(item){
        item.is_check = true;
      },
      toYc(item){//显示图片删除
        item.is_check = false;
      },
      back(){
        me.$router.back();
      }
    }
  }
</script>

<style scoped>
  @import "djggg.css";
</style>